import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LegalLayout from "../components/LegalLayout";
import SEO from "../components/SEO";
import { CONTACT } from "../data/mock";

export default function Terms() {
  useEffect(() => {
    document.title = "Termini e Condizioni – A.C.D.T.";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative overflow-x-hidden">
      <SEO />
      <Navbar />
      <LegalLayout title="Termini e Condizioni" lastUpdate="01 Giugno 2026">
        <Section title="1. Soggetto erogatore">
          <p>
            I servizi offerti tramite il sito {CONTACT.website} sono erogati da <strong>{CONTACT.org}</strong>,
            con sede in {CONTACT.address}, C.F./P.IVA {CONTACT.cf}.
          </p>
        </Section>

        <Section title="2. Oggetto del contratto">
          <p>I presenti termini disciplinano:</p>
          <ul>
            <li>L'iscrizione all'Associazione e il pagamento della quota associativa;</li>
            <li>L'acquisto del Corso A.C.D.T. per la qualificazione professionale per Consulenti Digitali Tecnologici e di Sostenibilità;</li>
            <li>L'iscrizione al Registro Nazionale dei Consulenti ed Educatori Digitali.</li>
          </ul>
        </Section>

        <Section title="3. Prezzi e modalità di pagamento">
          <p>
            I prezzi indicati sul sito sono comprensivi degli eventuali oneri di legge. Il pagamento può
            essere effettuato tramite PayPal, Google Pay, Apple Pay, Klarna o bonifico bancario.
            Per il bonifico, l'iscrizione si perfeziona alla ricezione dell'accredito.
          </p>
        </Section>

        <Section title="4. Diritto di recesso">
          <p>
            Ai sensi degli artt. 52 e seguenti del D.Lgs. 206/2005 (Codice del Consumo), il consumatore
            ha diritto di recedere dal contratto entro <strong>14 giorni</strong> dalla data di acquisto,
            senza dover fornire alcuna motivazione.
          </p>
          <p>
            Il diritto di recesso si esercita inviando una comunicazione scritta a{" "}
            <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>. Il rimborso sarà effettuato entro
            14 giorni dalla ricezione della richiesta, con lo stesso mezzo di pagamento utilizzato.
          </p>
          <p>
            Il diritto di recesso <strong>decade</strong> qualora il socio abbia già fruito
            (anche parzialmente) dei contenuti formativi digitali, ai sensi dell'art. 59, lett. o)
            del Codice del Consumo, previa esplicita accettazione al momento dell'acquisto.
          </p>
        </Section>

        <Section title="5. Validità della tessera e dell'iscrizione">
          <p>
            La quota di tesseramento e l'iscrizione al Registro hanno validità di <strong>365 giorni</strong>
            dalla data di iscrizione. Il rinnovo avviene tramite pagamento della relativa quota dall'
            Area Riservata.
          </p>
        </Section>

        <Section title="6. Obblighi del socio">
          <p>L'iscrizione all'Associazione comporta:</p>
          <ul>
            <li>Il rispetto dello Statuto, del Codice di Condotta e del Codice Deontologico;</li>
            <li>L'obbligo di seguire le linee guida dell'Associazione;</li>
            <li>Per gli iscritti al Registro, l'obbligo di aggiornamento permanente (20 ore annue).</li>
          </ul>
        </Section>

        <Section title="7. Limitazione di responsabilità">
          <p>
            L'Associazione si impegna a fornire i servizi con la massima diligenza professionale.
            Non risponde di danni derivanti da utilizzo improprio dei contenuti formativi o
            inadempienze dell'utente.
          </p>
        </Section>

        <Section title="8. Foro competente e legge applicabile">
          <p>
            Per ogni controversia si applica la legge italiana. Il Foro competente è quello del consumatore,
            ai sensi dell'art. 66-bis del Codice del Consumo.
          </p>
        </Section>

        <Section title="9. ODR – Risoluzione online delle controversie">
          <p>
            Ai sensi del Regolamento UE 524/2013, il consumatore può utilizzare la piattaforma
            europea ODR per la risoluzione extragiudiziale delle controversie:{" "}
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">
              ec.europa.eu/consumers/odr
            </a>.
          </p>
        </Section>
      </LegalLayout>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="text-xl md:text-2xl font-extrabold text-[#0a1f55] mb-3">{title}</h2>
      <div className="text-[15px] text-slate-700 leading-relaxed space-y-3 [&_a]:text-[#102a6b] [&_a]:underline [&_a]:font-semibold [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_ul]:space-y-1.5 [&_ol]:space-y-1.5">
        {children}
      </div>
    </section>
  );
}
